import { ChangeDetectorRef } from '@angular/core';

export class ChangeDetector {
  constructor(protected window: Window, protected cd: ChangeDetectorRef) {}

  private detectChangesTimer = 0;
  protected $detectChanges(delay = 0) {
    if (!this.detectChangesTimer) {
      this.detectChangesTimer = this.window.setTimeout(() => {
        this.cd.detectChanges();
        this.detectChangesTimer = 0;
      }, delay);
    }
  }
}
